import { render, staticRenderFns } from "./TransactionFundraisingRewardPurchase.vue?vue&type=template&id=6da5d2c4&scoped=true&"
import script from "./TransactionFundraisingRewardPurchase.vue?vue&type=script&lang=ts&"
export * from "./TransactionFundraisingRewardPurchase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da5d2c4",
  null
  
)

export default component.exports